<template>
  <div>
    <v-text-field
      @input="handleSlotSizeChange"
      :value="defaultValue"
      :label="$t('appointment.label.slotSize')"
      :hint="$t('appointment.formCreate.hints.slotSize')"
      :append-icon="$t('appointment.formCreate.hints.minutes')"
      :rules="[numberRule]"
      length="3"
      class="input-slot-size"
      type="number"
      persistent-hint
      outlined
    />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'HSlotSize',

  props: {
    isAppointment: {
      type: Boolean,
      default: false
    },

    defaultValue: {
      type: String | Number,
      default: 0
    }
  },

  methods: {
    ...mapMutations(['setAppointmentFields']),

    handleSlotSizeChange(value) {
      if (!this.isAppointment) {
        this.$emit('input', value)
      } else {
        this.setAppointmentFields({ slot_size: value })
      }
    },
  },

  data() {
    return {
      numberRule: value => /^\d+$/.test(value) && value >= 0 && value <= 420 || this.$t('appointment.formCreate.errors.slotSize'),
    }
  }
}
</script>

<style>
.input-slot-size .v-input__append-inner .v-icon{
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
}

.input-slot-size .v-input__append-inner {
  margin-right: 20px;
}
</style>
